import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

/**
 * Settings → Locations (T079 / E10). Per-dealership list of physical
 * rooftops, same CRUD shape as leadFollowUp's task reasons.
 */
export default {
  // → [{ id, name, code, active, sortOrder, updatedAt }]
  list:   ()           => api.get('/v1/settings/locations').then(unwrap),
  create: (body)       => api.post('/v1/settings/locations', body).then(unwrap),
  update: (id, body)   => api.patch(`/v1/settings/locations/${encodeURIComponent(id)}`, body).then(unwrap),
  remove: (id)         => api.delete(`/v1/settings/locations/${encodeURIComponent(id)}`).then(unwrap),
};
